import { useState } from "react";
import { Controller } from "react-hook-form";
import { IconButton, InputAdornment, MenuItem, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { AuthenticationTypes } from "../../../_helpers/Constant";
import { useTranslation } from "react-i18next";

const AuthenticationSection = ({ handleChangeInput, showPasswordIcon, disabled, control, errors, authTypes }) => {
  const { t } = useTranslation();
  const [isSqlAuthentication, setIsSqlAuthentication] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // const [decryptedFormData, setDecryptedFormData] = useState({});

  const handleChangeAuthenticationType = (event) => {
    setIsSqlAuthentication(event.target.value === "SQL Server Authentication");
  };

  // const handleFormatData = async () => {
  //   const [decryptedUser, decryptedPassword] = await decryptMultipleData([
  //     defaultValues?.user,
  //     defaultValues?.password,
  //   ]);

  //   const newData = {
  //     ...defaultValues,
  //     user: decryptedUser,
  //     password: decryptedPassword,
  //   };

  //   setDecryptedFormData(newData);
  // };

  // useLayoutEffect(() => {
  //   defaultValues?.user && handleFormatData();
  // }, []);

  const passwordVisibilityIcon = showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />;
  return (
    <>
      <Grid size={12}>
        <Typography variant="h6">{t("Authentication")}</Typography>
      </Grid>
      <Grid size={12}>
        <Controller
          control={control}
          name="authenticationType"
          // defaultValue={defaultValues.authenticationType || authTypes[0]?.value || ""}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              select
              label={t("Authentication Type")}
              required
              size="small"
              error={!field.value || !AuthenticationTypes.some((opt) => opt.value === field.value)}
              onChange={(e) => {
                field.onChange(e.target.value);
                handleChangeAuthenticationType(e);
              }}>
              {authTypes.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          control={control}
          name="user"
          // defaultValue={defaultValues?.user}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              disabled={Boolean(disabled || isSqlAuthentication)}
              label={t("User")}
              required
              fullWidth
              error={Boolean(errors.user)}
              variant="outlined"
              autoComplete="off"
              size="small"
              onChange={(e) => handleChangeInput(e, field)}
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          control={control}
          name="password"
          // defaultValue={defaultValues?.password}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              inputProps={{ autoComplete: "new-password" }}
              disabled={disabled || isSqlAuthentication}
              fullWidth
              onChange={(e) => handleChangeInput(e, field)}
              error={Boolean(errors.password)}
              label={t("Password")}
              required
              variant="outlined"
              size="small"
              type={showPassword ? "text" : "password"}
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {showPasswordIcon && (
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={() => setShowPassword(!showPassword)}>
                        {passwordVisibilityIcon}
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default AuthenticationSection;
